import { message } from "antd";
import { fetchBinReasons } from "../service/service";
import { handleError } from "../../../redux/makeApiCall";
import { SOMETHING_WENT_WRONG } from "../../../constants";
const reasonTypes = {
  BIN_TO_BIN_PICKER_LESS_QTY: "BIN_TO_BIN_PICKER_LESS_QTY",
  BIN_TO_BIN_RACKER: "BIN_TO_BIN_RACKER",
  BIN_TO_BIN_PICKER_MORE_QTY: "BIN_TO_BIN_PICKER_MORE_QTY",
};
const promiseStatus = {
  fulfilled: "fulfilled",
  rejected: "rejected",
};
const statusCode = {
  SUCCESS: 200,
};

export const getAllReasons = async ({ access_token, isRacker }) => {
  let params = {
    access_token,
    reasonName: reasonTypes.BIN_TO_BIN_PICKER_MORE_QTY,
  };
  if (isRacker) {
    params = {
      ...params,
      reasonName: reasonTypes.BIN_TO_BIN_RACKER,
    };
    const res = await fetchBinReasons(params);
    return {
      rackerReasons: res.data.responseData,
    };
  } else {
    let [moreQtyReasons, lessQuantityReasons] = await Promise.allSettled([
      fetchBinReasons(params),
      fetchBinReasons({
        ...params,
        reasonName: reasonTypes.BIN_TO_BIN_PICKER_LESS_QTY,
      }),
    ]);

    if (
      moreQtyReasons.status === promiseStatus.fulfilled &&
      moreQtyReasons.value.data.statusCode === statusCode.SUCCESS
    ) {
      moreQtyReasons = moreQtyReasons?.value?.data?.responseData;
    } else {
      const err = handleError(moreQtyReasons.reason);
      message.error(err || SOMETHING_WENT_WRONG);
    }
    if (
      lessQuantityReasons.status === promiseStatus.fulfilled &&
      lessQuantityReasons.value.data.statusCode === statusCode.SUCCESS
    ) {
      lessQuantityReasons = lessQuantityReasons?.value?.data?.responseData;
    } else {
      const err = handleError(lessQuantityReasons.reason);
      message.error(err || SOMETHING_WENT_WRONG);
    }
    return {
      moreQtyReasons,
      lessQuantityReasons,
    };
  }
};
